// extracted by mini-css-extract-plugin
module.exports = {"card":"RiskIndicators_card___XQJo","loaderWrapper":"RiskIndicators_loaderWrapper__VkDNv"};